import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import vuetify from './plugins/vuetify';
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueApexCharts from 'vue-apexcharts'

import './vee-validate';
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)
Vue.use(require('vue-moment'));

const EventBus = new Vue();
Vue.prototype.$bus = EventBus;

Vue.use(ArgonDashboard)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')